import {EnvironmentAdmin} from 'compob2b-libs';

export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = true;
  serverPicturesPath = 'https://camozzidata.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://camozzidata.compo-soft.ru/documents';
  serverApi =  'https://camozzidata.compo-soft.ru/api/v1';
  serverUrl =  'https://camozzidata.compo-soft.ru';
  impersonate = true;
  impersonatePortalPath = 'https:/camozzi.compo-soft.ru/cabinet/sign-in';
  accessRolesCatalog = true;
}

export const environment = new EnvironmentAdminProd();
